import React from 'react'
import { TooltipLabel } from '../../../design-system'
import { MetadataValue, MetadataSubvalue } from '../../applications-grid/shared'
import { Link } from '@contrast-security-inc/design-system-typography'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const tooltipLinkCss = css`
  color: ${theme.color.turquoise50} !important;
`

export function Metadata({ values }: { readonly values: MetadataValue[] }) {
  return (
    <React.Fragment>
      {values
        .slice(0, 5)
        .map(({ name, value, type, subfields }, valueIndex) => {
          return (
            <li key={valueIndex}>
              <TooltipLabel
                label={name}
                renderValue={() => {
                  return type === 'PERSON_OF_CONTACT' && subfields ? (
                    <Subvalue subfields={subfields} />
                  ) : (
                    value
                  )
                }}
              />
            </li>
          )
        })}
      {values.length > 5 && <li>&hellip;</li>}
    </React.Fragment>
  )
}

function Subvalue({ subfields }: { readonly subfields: MetadataSubvalue[] }) {
  const contactName = subfields.find(({ type }) => type === 'CONTACT_NAME')
  const phone = subfields.find(({ type }) => type === 'PHONE')
  const email = subfields.find(({ type }) => type === 'EMAIL')

  const displayName = contactName ? contactName.value : ''

  if (email) {
    return (
      <span>
        <Link className={tooltipLinkCss} href={`mailto:${email.value}`}>
          {displayName ? displayName : email.value}
        </Link>
        {phone && <span>, {phone.value}</span>}
      </span>
    )
  }

  if (phone) {
    return (
      <span>
        <Link className={tooltipLinkCss} href={`tel:${phone.value}`}>
          {displayName ? displayName : phone.value}
        </Link>
      </span>
    )
  }

  return <span>{displayName}</span>
}
